export default __webpack_public_path__ + "static/security_compliance_soc-cf54666936744575d21c7c0b8f61291f.png";